import {
  TIMELINE_TYPES,
  TIMELINE_ASSIGNER_TYPES
} from 'utils/constants/timeline';
import Loader from 'features/Loader/Loader';
import { connect } from 'react-redux';
import { calculateLastActive, populateDate } from 'utils/date';
import React from 'react';
import ItemDefault from './itemDefault';
import ItemGoal from './itemGoal';
import ItemProgress from './itemProgress';
import ItemMeal from './itemMeal';
import TimelineLoad from './timelineLoad';
import './timeline.scss';

const Timeline = props => {
  const {
    events,
    enableLoadButton,
    isClientTimeline,
    handleLoadMore,
    trainer,
    loadingTrainer,
    loadingTimeline
  } = props;

  if (loadingTimeline || loadingTrainer) {
    return <Loader />;
  }
  return (
    <section className="timeline-list">
      <ul>
        {events?.map(event => {
          let avatarImage,
            avatarUrl,
            name = '';

          if (
            isClientTimeline &&
            event.assigner_type === TIMELINE_ASSIGNER_TYPES.TRAINER
          ) {
            avatarImage = trainer?.photo;
            avatarUrl = '/profile';
            name = `${trainer?.first_name} ${trainer?.last_name}`;
          } else {
            avatarImage = event.client_photo_url;
            avatarUrl = `/clients/${event.client_id}`;
            name = event.client_name;
          }
          const period = `${calculateLastActive(event.created_at)}`;
          const title = event.info && event.info.title;
          var message = event.info && event.info.message;
          const date = event.info && event.info.date;
          if (message && date) message = populateDate(message, date);

          if (event.type === TIMELINE_TYPES.TRAINER_ADD_GOAL)
            return (
              <li key={event.id}>
                <ItemGoal
                  avatarImage={avatarImage}
                  avatarUrl={avatarUrl}
                  name={name}
                  period={period}
                  title={title}
                  message={message}
                  clientId={event.client_id}
                />
              </li>
            );
          else if (
            event.type.includes(
              TIMELINE_TYPES.CLIENT_LOGS_MEAL_PRE_TRANSFORMATION
            )
          )
            return (
              <li key={event.id}>
                <ItemMeal
                  avatarImage={avatarImage}
                  avatarUrl={avatarUrl}
                  name={name}
                  period={period}
                  imageSrc={event.info && event.info.urls && event.info.urls[0]}
                  imageLabel={event.meal_label}
                  title={title}
                  message={message}
                />
              </li>
            );
          else if (event.type === TIMELINE_TYPES.TRAINER_ADD_PROGRESS_PHOTO)
            return (
              <li key={event.id}>
                <ItemProgress
                  avatarImage={avatarImage}
                  avatarUrl={avatarUrl}
                  name={name}
                  period={period}
                  progressImage1={
                    event.info &&
                    event.info.urls &&
                    event.info.urls.length &&
                    event.info.urls[0]
                  }
                  progressImage2={
                    event.info &&
                    event.info.urls &&
                    event.info.urls.length > 1 &&
                    event.info.urls[1]
                  }
                  progressImage3={
                    event.info &&
                    event.info.urls &&
                    event.info.urls.length > 2 &&
                    event.info.urls[2]
                  }
                  title={title}
                  clientId={event.client_id}
                />
              </li>
            );
          else
            return (
              <li key={event.id}>
                <ItemDefault
                  avatarImage={avatarImage}
                  name={name}
                  period={period}
                  title={title}
                  message={message}
                  avatarUrl={avatarUrl}
                  clientId={event.client_id}
                  eventId={event.event_id}
                  eventType={event.type}
                />
              </li>
            );
        })}
      </ul>
      {enableLoadButton && <TimelineLoad handleLoadMore={handleLoadMore} />}
    </section>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer,
    loadingTrainer: state.trainerProfileReducer.loading,
    loadingTimeline: state.timelineReducer.loading
  };
}

export default connect(mapStateToProps, null)(Timeline);
